export const daysOfWeek = [
    { english: "Sunday", arabic: "الاحد" },
    { english: "Monday", arabic: "الاثنين" },
    { english: "Tuesday", arabic: "الثلاثاء" },
    { english: "Wednesday", arabic: "الاربعاء" },
    { english: "Thursday", arabic: "الخميس" },
    { english: "Friday", arabic: "الجمعة" },
    { english: "Saturday", arabic: "السبت" }
];